function ensureBeginsWith(str, prefix) {
    if (!str) {
        return '';
    }
    return str.indexOf(prefix) === 0 ? str : prefix + str;
}
function completePathname(pathname) {
    return ensureBeginsWith(pathname, '/');
}
function completeHash(hash) {
    return ensureBeginsWith(hash, '#');
}
function completeQuery(query) {
    return ensureBeginsWith(query, '?');
}
function stripPrefix(str, prefix) {
    return str.indexOf(prefix) === 0 ? str.slice(prefix.length) : str;
}
function hasBaseSegment(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBaseSegment(path, prefix) {
    return hasBaseSegment(path, prefix) ? path.substr(prefix.length) : path;
}

export { ensureBeginsWith, completePathname, completeHash, completeQuery, stripPrefix, stripBaseSegment };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hickory/location-utils/dist/hickory-location-utils.es.js
// module id = 255
// module chunks = 3